export enum ESamplingMode {
    Single = 1,
    Successive = 2,
    Simultaneous = 3,
    SuccessiveAndSimultaneous = 4,
}